// Vartotojo vardas programėlėje.
//
// ⚠️ 2026-09-22: anksčiau dviejose vietose buvo įrašytas tikras vardas.
// Dabar numatytasis — „Keliautojas", o vardą kiekvienas pasikeičia pats.
// Laikoma tik jo paties telefone (localStorage), niekur nesiunčiama.

const RAKTAS = 'vardas'
export const NUMATYTAS = 'Keliautojas'

function isvalyti(reiksme) {
  return (reiksme || '').trim().slice(0, 24)
}

export function getVardas() {
  try {
    return isvalyti(localStorage.getItem(RAKTAS)) || NUMATYTAS
  } catch {
    return NUMATYTAS
  }
}

export function setVardas(naujas) {
  const s = isvalyti(naujas)
  try {
    if (s) localStorage.setItem(RAKTAS, s)
    else localStorage.removeItem(RAKTAS)
  } catch {}
  return s || NUMATYTAS
}

export function inicialas(vardas) {
  const s = isvalyti(vardas) || NUMATYTAS
  return s[0].toUpperCase()
}
